<template>
<div class="chapter">
<div class="inner_page">
<div id="about-the-author">
<div class="story">
<div class="image1">
<img alt="CunninghamNew.tif" class="frame-1" src="images/CunninghamNew_fmt.jpeg"/>
<p class="ital-cntr">Scott Cunningham</p>
</div>
<p class="txnoi">Scott Cunningham learned about Wicca while still in high school, and practiced elemental magic for over twenty years. He was the author of more than forty books, both fiction and non-fiction, sixteen of them published by Llewellyn Publications. He experienced, researched, then wrote about what he learned in his magical training. Scott’s books reflect a broad range of interests within the New Age sphere, where he was highly regarded. He passed from this life on March 28, 1993, after a long illness.</p>
<div class="image2">
<img alt="cunningham_pent_beach.tif" class="frame-1" src="images/cunningham_pent_beach_fmt.jpeg"/>
<p class="ant">Linda Mace Pirkle Photography</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?b8b320c2